import type { ConnectedProfile } from "../../../../types/customer";

/** API may send non-array; guards `.some` / `.filter` on consumers. */
export function asConnectedProfileArray(value: unknown): ConnectedProfile[] {
  return Array.isArray(value) ? value : [];
}
